// extracted by mini-css-extract-plugin
module.exports = {"editButton":"InteractiveMessageButton_editButton__9MheQ","editIcon":"InteractiveMessageButton_editIcon__3ioCO","modal":"InteractiveMessageButton_modal__1XRUs"};